import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Layout from '../layout.vue'
import Index from './index'
import BlankLayout from '../../layout/blankLayout.vue'
import NotificationList from './notification/list.vue'
import NotificationEdit from './notification/editor.vue'
import LayoutTemplateList from './layoutTemplate/list.vue'
import LayoutTemplateEdit from './layoutTemplate/editor.vue'

const basePath = '/v-admin/notification-management'
const i18nPrefix = 'admin.company.notification'

const notificationRoute = {
  path: `${basePath}/notification`,
  redirect: `${basePath}/notification/list`,
  component: BlankLayout,
  meta: {
    titleI18nKey: `${i18nPrefix}.title.messageManagement`,
    breadcrumb: { labelI18nKey: `${i18nPrefix}.tabMenu.messageManagement` }
  },
  children: [
    {
      path: `${basePath}/notification/add/:systemTemplateId`,
      component: NotificationEdit,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.notificationAdd`,
        isEditMode: false
      }
    },
    {
      path: `${basePath}/notification/edit/:templateId`,
      component: NotificationEdit,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.notificationEdit`,
        isEditMode: true
      }
    },
    {
      path: `${basePath}/notification/view/:templateId/`,
      component: NotificationEdit,
      meta: {
        isViewMode: true,
        titleI18nKey: `${i18nPrefix}.title.notificationView`
      }
    }
  ]
}

const templateRoute = {
  path: `${basePath}/layout-template`,
  redirect: `${basePath}/layout-template/list`,
  component: BlankLayout,
  meta: {
    titleI18nKey: `${i18nPrefix}.title.layoutTemplateManagement`,
    breadcrumb: { labelI18nKey: `${i18nPrefix}.tabMenu.layoutTemplateManagement` }
  },
  children: [
    {
      path: `${basePath}/layout-template/edit/:layoutTemplateId`,
      component: LayoutTemplateEdit,
      meta: {
        isEditMode: true,
        titleI18nKey: `${i18nPrefix}.title.layoutEdit`
      }
    },
    {
      path: `${basePath}/layout-template/add`,
      component: LayoutTemplateEdit,
      meta: {
        isEditMode: false,
        titleI18nKey: `${i18nPrefix}.title.layoutAdd`
      }
    },
    {
      path: `${basePath}/layout-template/view/:layoutTemplateId`,
      component: LayoutTemplateEdit,
      meta: {
        isViewMode: true,
        titleI18nKey: `${i18nPrefix}.title.layoutView`
      }
    }
  ]
}

export const tabMenuRoute = {
  path: `${basePath}`,
  redirect: `${basePath}/notification/list`,
  component: Index,
  meta: {
    titleI18nKey: `${i18nPrefix}.title.messageManagement`,
    breadcrumb: { hidden: true }
  },
  children: [
    {
      path: `${basePath}/notification/list`,
      component: NotificationList,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.messageManagement`,
        tabMenuLabelI18nKey: `${i18nPrefix}.tabMenu.messageManagement`,
        breadcrumb: { labelI18nKey: `${i18nPrefix}.tabMenu.messageManagement` }
      }
    },
    {
      path: `${basePath}/layout-template/list`,
      component: LayoutTemplateList,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.layoutTemplateManagement`,
        tabMenuLabelI18nKey: `${i18nPrefix}.tabMenu.layoutTemplateManagement`,
        breadcrumb: { labelI18nKey: `${i18nPrefix}.tabMenu.layoutTemplateManagement` }
      }
    }
  ]
}

export default {
  path: `${basePath}`,
  redirect: `${basePath}/notification`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_NOTIFICATION_TEMPLATE_MANAGEMENT', 'PREMIUM_CUSTOM_EMAIL'],
    titleI18nKey: `${i18nPrefix}.title.messageManagement`,
    menu: {
      get label () {
        return i18n.t(`${i18nPrefix}.title.messageManagement`)
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    tabMenuRoute,
    notificationRoute,
    templateRoute
  ]
}
